module.exports = __webpack_public_path__ + "img/left-menu-title.2052c7dd.png";